import { CircleLoader } from 'components';

let SignIn = () => {
    return (
        <CircleLoader />
    );
}

export default SignIn;